export function formatNumber(num: number) {
  const units = [
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'B' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' },
  ]

  for (const unit of units) {
    if (num >= unit.value) {
      const formatted = (num / unit.value).toFixed(num % unit.value === 0 ? 0 : 1)
      return formatted + unit.symbol
    }
  }
  return num.toString()
}
